<template>
  <div>
    <router-view></router-view>
    <van-tabbar v-model="active" route>
      <van-tabbar-item name="0" icon="home-o"  to="/home/editBascInfo">{{$t('message.home')}}</van-tabbar-item>
      <van-tabbar-item name="1" icon="gem-o"  to="/schedule">{{$t('message.loan_record')}}</van-tabbar-item>
      <van-tabbar-item name="2" icon="friends-o" to="/home/my">{{$t('message.home_my')}}</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    name: "home",
    data() {
      return {
        active: 0,
      };
    },
    methods:{
      //   onChange(index){
      //     this.activeColor='#07c975';
      //     switch (index) {
      //       case "0":
      //         this.active=0;
      //         this.$router.push("/home/editBascInfo");
      //         break;
      //       case "1":
      //         this.active=1;
      //         this.$router.push("/schedule");
      //         break;
      //       default:
      //         this.active=2;
      //         this.$router.push("/home/my");
      //     }
      //   }
    }
  }
</script>

<style scoped lang="scss">
  .van-tabbar-item--active{
    color:$color;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue